export const FiltersButton = {
  init() {
    this.cacheSelectors();
    this.bindEvents();
  },
  cacheSelectors() {
    this.buttons = document.querySelectorAll('.category-btn');
    this.grids = document.querySelectorAll('.resultado__grid');
  },

  bindEvents() {

    this.buttons.forEach((item) => { item.addEventListener("click", () => {
      if(!item.classList.contains("active")){
        this.Events.handleButtonClick(item);
      }
    });
    });

  },

  Events: {
    handleButtonClick(item) {
      const selfPosts = FiltersButton;
      const target = item.getAttribute("data-target");
      console.log(target)

      selfPosts.buttons.forEach((elem) => {
        elem.classList.remove("active");
      })

      item.classList.add("active");

      selfPosts.grids.forEach((elem) => {
        elem.classList.remove("active");
      });
      const elemTarget = document.querySelector(`${target}`);
      if (elemTarget) {
        elemTarget.classList.add("active");
      } else {
        console.warn(`Elemento com o seletor ${target} não foi encontrado.`);
      }
      // elemTarget.classList.add("active");
    },
  },
};

document.addEventListener('DOMContentLoaded', () => {
  FiltersButton.init();
});
